import { Box, VStack } from '@chakra-ui/react';
import { ChangelogEntry } from './ChangelogEntry';

export const Changelog = () => {
    return (
        <Box>
            <Box className={'release-notes'}>
                <VStack>
                    {/* Add new changelog entries here */}
                    <ChangelogEntry
                        date={'February 26, 2024'}
                        updates={['Adding new loading bar across the entire site']}
                    />
                    <ChangelogEntry
                        date={'February 23, 204'}
                        updates={[
                            `Change the "Setup 2FA" button throughout the app to open the 2FA page directly instead of having to navigate to it`,
                            'Change the "Manage Account" button on the settings page to open the account management page directly',
                        ]}
                    />
                    <ChangelogEntry
                        date={'February 22, 2024'}
                        updates={[
                            "Fixes a bug where our app wouldn't load in firefox private mode",
                        ]}
                    />
                    <ChangelogEntry
                        date={'February 21, 2024'}
                        updates={[
                            'Add a blur to the pop warning warning of private information on the dashboard page',
                            'Reset sorting options to default when resetting filters on Discover and Favorites pages',
                        ]}
                    />
                    <ChangelogEntry
                        date={'February 14, 2024'}
                        updates={[
                            'Huge update to kick off 2024! Here`s what`s new:',
                            'Introducing STREAMGOLD. This is the virtual currency of the STREAMSIX platform and can be purchased from the store page.',
                            'New shop page where STREAMGOLD can be used to purchase in-game products (such as Bingles, with more to come).',
                            'Connect and support other users with STREAMSIX Subscriptions. You can subscribe to another user from their profile page.',
                            'User Interface updates across the whole site.',
                        ]}
                    />
                    <ChangelogEntry
                        date={'November 5, 2023'}
                        updates={[
                            'Added Race Day Rampage streamer leaderboards to user profile page.',
                        ]}
                    />
                    <ChangelogEntry
                        date={'November 1, 2023'}
                        updates={[
                            'Added in-game currency bundles for Bingo and Leviathan to the store page, and corresponding six page',
                            'Bundles can be purchased with STREAMGOLD',
                        ]}
                    />
                    <ChangelogEntry
                        date={'Dec 19, 2023'}
                        updates={[
                            'Updated Privacy Policy',
                            'Added Code of Conduct',
                            'Added Terms of Use',
                        ]}
                    />
                    <ChangelogEntry
                        date={'October 5, 2023'}
                        updates={['Many bug fixes across the whole site']}
                    />
                    <ChangelogEntry
                        date={'September 20, 2023'}
                        updates={['Added wallet section to creator dashboard']}
                    />
                    <ChangelogEntry
                        date={'September 15, 2023'}
                        updates={[
                            'Edit profile UI updated to new design',
                            'Added leaderboard for Marbles',
                        ]}
                    />
                    <ChangelogEntry
                        date={'September 6, 2023'}
                        updates={[
                            "Greyed out the profile action buttons when user isn't signed in",
                        ]}
                    />
                    <ChangelogEntry
                        date={'September 5, 2023'}
                        updates={[
                            'Removed welcome page. Initial page is instead the discover page',
                            "Made the following pages accessible to users who aren't signed in to a STREAMSIX account: the SIX list page, the discover page, the leaderboard page, the public profile page and the individual SIX page",
                        ]}
                    />
                    <ChangelogEntry
                        date={'Sept 4, 2023'}
                        updates={['Updated profile pages to new design']}
                    />
                    <ChangelogEntry
                        date={'August 24, 2023'}
                        updates={[
                            'Added desktop Stream Gold donation UI',
                            'Added prevention from entering negative or decimal amounts for donation',
                        ]}
                    />
                    <ChangelogEntry
                        date={'August 22, 2023'}
                        updates={['Added mobile Stream Gold Donation UI', 'Add transactions page']}
                    />
                    <ChangelogEntry
                        date={'August 17, 2023'}
                        updates={[
                            'Updated most pages to new design',
                            'Support for desktop friendly views',
                            'Added leaderboards on sixes pages (except for marbles)',
                            'Improved load times',
                        ]}
                    />
                    <ChangelogEntry
                        date={'July 5, 2023'}
                        updates={[
                            'Added a redirect to the welcome page when logging out from the settings page',
                        ]}
                    />
                    <ChangelogEntry
                        date={'June 26, 2023'}
                        updates={['Remove user following count from public profile']}
                    />
                    <ChangelogEntry
                        date={'June 18, 2023'}
                        updates={[
                            'Added ability to press enter to search for users on the discovery page',
                        ]}
                    />
                    <ChangelogEntry
                        date={'June 18, 2023'}
                        updates={['Offline users are now included in the search results']}
                    />
                    <ChangelogEntry
                        date={'June 16, 2023'}
                        updates={['Removed offline users from discover page']}
                    />
                    <ChangelogEntry
                        date="June 15, 2023"
                        updates={[
                            'Fixed bug where the default image briefly flashes when avatar images load for the first time',
                        ]}
                    />
                    <ChangelogEntry
                        date="June 12, 2023"
                        updates={[
                            'Added button in profile settings to request push notification permission from the device',
                        ]}
                    />
                    <ChangelogEntry
                        date="June 8, 2023"
                        updates={[
                            'Added changelog to profile settings page',
                            'Check back here for the latest updates',
                        ]}
                    />
                </VStack>
            </Box>
        </Box>
    );
};
